import { useEffect } from "react";
import { PageContent, useGetAllParams } from "../hospital-diseases/comp";
import { sendBaikePV } from "../../utils/mping";

export default () => {
  const paramsInfo = useGetAllParams([
    "selectedProvince",
    "cityId",
    "diseaseId",
  ]);
  console.log("paramsInfo", paramsInfo);

  // const {
  //   selectedProvince,
  //   cityId,
  //   diseaseId,
  //   provinceId,
  //   hospitalId,
  //   departmentId,
  //   secondDepartId,
  //   departmentCode,
  // } = paramsInfo;

  useEffect(() => {
    sendBaikePV("InternetHospital_Regionaldiseases");
  }, []);

  return <PageContent paramsInfo={paramsInfo} />;
};
